var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindows = function SvgWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 1.5H1.5V11.25H11.25V1.5ZM11.25 12.75H1.5V22.5H11.25V12.75ZM12.75 1.5H22.5V11.25H12.75V1.5ZM22.5 12.75H12.75V22.5H22.5V12.75Z",
    fill: "#0078D4"
  })));
};
export default SvgWindows;